import {
    ADD_TEST_PARAMS,
    SET_OVERRIDES,
    SET_VISITOR_ID,
    SET_CACHED_PARAMS,
} from './types';

const addTestParams = (payload) => ({
    payload,
    type: ADD_TEST_PARAMS,
});

const setTestOverrides = (payload) => ({
    payload,
    type: SET_OVERRIDES,
});

const setVisitorId = (visitorId) => ({
    payload: visitorId,
    type: SET_VISITOR_ID,
});

const setCachedTestParams = (payload) => ({
    payload,
    type: SET_CACHED_PARAMS,
});

export {
    addTestParams,
    setCachedTestParams,
    setTestOverrides,
    setVisitorId,
};
